import request from "@/utils/request";
export function fetchList(data) {
  return request({
    url: "/whg-park/api/activityItem/list",
    method: "post",
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: "/whg-park/api/activityItem/insert",
    method: "post",
    data: data
  });
} // 删除

export function fetchDelete(data) {
  return request({
    url: "/whg-park/api/activityItem/deletePerformance",
    method: "post",
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: "/whg-park/api/activityItem/update",
    method: "post",
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: "/whg-park/api/activityItem/get",
    method: "post",
    data: data
  });
}